// extracted by mini-css-extract-plugin
module.exports = {"accordion":"styles_accordion__EeKnl","contentWrapper":"styles_contentWrapper__rjPcu","content":"styles_content__mGrY_"};